<template>
    <div class="main-cn">
        <div class="main-bd mg20 pro-visible">
            <el-row class="searchSection">
                <SearchForm 
                :params="searcheModel" 
                :fields="fields" 
                :cache_field="'search_order_config_' + activeName + '_' + this.$route.path" 
                @search="submitSearch" 
                @reset="resetForm" 
                :key="search_form_key"
                :loading="loading"> 
                </SearchForm>
                
            </el-row>
            <el-row class="addBtn">
                <span class="import-order-action">
                    <ImportFile 
                    v-if="Acs('/import/import-order-queue')"
                    :templateFileUrl="'/api/export/import-order-queue' + '-template'" 
                    url="/api/import/import-order-queue"  
                    :params="searcheModel" 
                    dialogTitle="导入订单记录"
                    buttonText="导入订单记录"
                    buttonType="success"
                    :err_fields="err_fields"
                    @import_success="importSuccess">
                    </ImportFile>
                    <el-tooltip placement="top" effect="dark">
                        <div slot="content" class="import-order-tip-content">
                            <div>订单导入记录：批量导入客户产品</div>
                            <div>如果客户目前已经生效了，不会继续生成</div>
                            <div>如果客户有部分产品没生效，就把没生效产品创建试用订单</div>
                        </div>
                        <i class="el-icon-info import-order-tip"></i>
                    </el-tooltip>
                </span>
                <ExportFile 
                url="/api/export/import-order-queue" 
                :params="searcheModel" 
                filename="订单导入记录" 
                buttonName="导出Excel"
                @click.native.stop>
                </ExportFile>

                <el-button type="info" size="small" @click="batchReset()" :disabled="multipleSelection.length == 0" :loading="reset_loading">批量重置</el-button>
                <el-button type="warning" size="small" @click="batchManual()" :disabled="multipleSelection.length == 0" :loading="reset_loading">批量标记手动处理</el-button>

                <!--ImportFile
                v-if="Acs('/import/import-order-queue')"
                :templateFileUrl="'/api/export/import-order-queue' + '-template'" 
                url="/api/import/import-order-queue?scenario=repeat"  
                :params="searcheModel" 
                dialogTitle="重复导入订单记录" 
                buttonText="重复导入订单记录"
                buttonType="success"
                :err_fields="err_fields"
                @import_success="importSuccess">
                </ImportFile-->

            </el-row>
            <el-table 
            v-loading="loading"
            :data="list" 
            border 
            height="700"
            :header-cell-style="{background: '#f3faff'}"
            @sort-change="submitSearch(null, $event)"
            @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="40"></el-table-column>
                <el-table-column prop="customer_id" label="客户ID" width="75"></el-table-column>
                <el-table-column prop="customer_name" label="客户名称">
                    <template slot-scope="scope">
                        <el-button type="text" @click="handleView(scope.row)">
                            {{ scope.row.customer_name }}
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="province_name" label="省" width="65"></el-table-column>
                <el-table-column prop="city_name" label="市"></el-table-column>
                <el-table-column prop="district_name" label="区"></el-table-column>
                <el-table-column prop="szxy_domain" label="域名" width="100"></el-table-column>
                <!-- <el-table-column prop="jb3_domain" label="校本3域名"></el-table-column> -->
                <el-table-column prop="xd" label="学段" width="130"></el-table-column>
                <el-table-column prop="contact_name" label="联系人" width="70"></el-table-column>
                <!-- <el-table-column prop="contact_mobile" label="手机号" width="100"></el-table-column> -->
                <el-table-column prop="account" label="账号"></el-table-column>
                <el-table-column prop="order_id" label="订单ID" width="70">
                    <template slot-scope="scope">
                        <router-link target="_blank" :to="{path: '/order/view', query: {id: scope.row.order_id}}">
                            {{scope.row.order_id}}
                        </router-link>
                    </template>
                </el-table-column>
                <el-table-column prop="status_memo" label="状态" width="80">
                    <template slot-scope="scope">
                        <el-link v-if="scope.row.status == 0" type="info" :underline="false">{{scope.row.status_memo}}</el-link>
                        <el-link v-else-if="scope.row.status == 1" type="success" :underline="false">{{scope.row.status_memo}}</el-link>
                        <el-link v-else-if="scope.row.status == 2" type="danger" :underline="false">{{scope.row.status_memo}}</el-link>
                        <el-link v-else-if="scope.row.status == 3" type="warning" :underline="false">{{scope.row.status_memo}}</el-link>
                        <span v-else>{{scope.row.status_memo}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="flag_name" label="标识" width="70"></el-table-column>
                <el-table-column prop="reason" label="失败原因" width="350"></el-table-column>
                <el-table-column prop="created_at" label="创建时间" width="100"></el-table-column>
                <!-- <el-table-column label="操作"  fixed="right" width="100">
                    <template slot-scope="scope">
                        <el-button v-if="Acs('/customers/my_update')" @click="handleUpdateMyCustomer(scope.row)" type="text" size="small">编辑</el-button>
                        <el-button v-if="Acs('/customers/update')" @click="handleUpdate(scope.row)" type="text" size="small">编辑</el-button>
                        <el-button type="text" size="small" @click="showDeleteDialog(scope.row)" v-if="Acs('/customers/delete')" >删除</el-button>
                    </template>
                </el-table-column> -->
            </el-table>
            <MyPagination :linkPage="linkPage" @size-change="handleSizeChange" @current-change="handleCurrentChange"></MyPagination>
        </div>
    </div>
  </template>
  <style scoped>
  .import-order-action {
    display: inline-flex;
    align-items: center;
    margin-right: 10px;
    vertical-align: middle;
  }

  .import-order-tip {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    margin-left: 8px;
    color: #606266;
    cursor: pointer;
    font-size: 15px;
    transition: color .2s;
  }

  .import-order-tip:hover {
    color: #409EFF;
  }

  .import-order-tip-content {
    line-height: 22px;
    max-width: 360px;
  }
  </style>
  <script>
  import ImportQueueService from "~/services/ImportQueue";
  import SearchForm from "~/widgets/SearchForm.vue";
  import MyPagination from "~/widgets/MyPagination.vue";
  import ExportFile from "~/widgets/ExportFile.vue";
  import ImportFile from "~/widgets/ImportFile.vue";
  export default {
    components: {
        SearchForm,
        MyPagination,
        ExportFile,
        ImportFile
    },
  
    props: {

    },
  
    data() {
        return {
            loading: false,
            reset_loading: false,
            searcheModel: {},
            // 分页信息
            linkPage: null,
            list: [],
            search_form_key: 0,
            fields: [],
            activeName: 'import-order',
            err_fields:{
                line_num: '行数',
                error_str: '异常原因',
                customer_id: '客户ID',
                szxy_domain: '域名前缀',
                xd: '学段',
                contact_name: '联系人',
                contact_mobile: '手机号',
            },
            multipleSelection: []
        };
    },
  
    created() {
        this.resetForm();
    },
  
    methods: {
        //重置按钮
        resetForm() {
            this.searcheModel = {
                customer_name: '',
                province_id: 0,
                city_id: 0,
                district_id: 0,
                created_time: [],
                status: '',
            };
            this.list = [];
            this.fields = [
                {field: 'base', label: '基础信息筛选条件', children: [
                    {field: 'customer_name', label: '客户名称', type: 'components', ref: 'customer', components: 'CustomerSelect', change: 'changeObjValue'},
                    {field: 'district_id', label: '所在地区', type: 'components', ref: 'district', components: 'DistrictCascader', change: 'changeDistrict'},
                    {field: 'domain', label: '域名', type: 'input'},
                    // {field: 'stages', label: '开设学段', type: 'select', list: [{value: 'is_grade_school', label: '小学'}, {value: 'is_middle_school', label: '初中'}, {value: 'is_high_school', label: '高中'}, {value: 'is_vsh_school', label: '职中'}], multiple: true, clearable: true},
                    {field: 'status', label: '状态', type: 'select', list: [{value: '', label: '不限'}, {value: 0, label: '待执行'}, {value: 1, label: '执行成功'}, {value: 2, label: '执行失败'}, {value: 3, label: '手动处理'}]},
                    {field: 'flag', label: '标识', type: 'select', list: [{value: '', label: '不限'}, {value: 'import', label: '首次'}, {value: 'repeat', label: '重复'}]},
                ]},
                {field: 'date', label: '时间筛选条件', children: [
                    {field: 'created_at', label: '创建时间', type: 'daterange'},
                    // {field: 'order_created_at', label: '录单时间', type: 'daterange'},
                ]},
            ];
            this.search_form_key ++;
            this.submitSearch();
        },

        // 筛选查询
        submitSearch(params = null, sort = null) {
            this.list = [];
            if(params){
                this.searcheModel = params;
            }
            if(sort && typeof sort.order !== undefined){
                this.searcheModel['sort_name'] = sort['prop'];
                this.searcheModel['sort_by'] = sort['order'];
            }
            params = _.clone(this.searcheModel);
            _.each(params, (val, key) => {
                // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                    delete params[key];
                }
            })
            this.getList(params);
        },
        
    
        //获取列表
        getList(params) {
            // loading 动画
            this.loading = true;
            ImportQueueService.getOrderQueueList(params).then((res) => {
                if (res.code == 0) {
                    this.list = res.data;
                }
                if (res._meta) {
                    this.linkPage = res._meta;
                }
                this.loading = false;
            }).catch((err) => {
                console.error(err);
                this.loading = false;
            });
        },

        batchReset(){
            const ids = this.multipleSelection.map(item => item.id);
            this.$confirm("确认将数据重新执行吗？", "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                center: true
            }).then(() => {
                this.reset_loading = true;
                ImportQueueService.orderQueueReset(ids).then((res) => {
                    if (res.code == 0) {
                        this.$message({
                            message: "操作成功",
                            type: "success"
                        });
                        this.submitSearch();
                    }
                    this.reset_loading = false;
                }).catch((err) => {
                    console.error(err);
                    this.reset_loading = false;
                });
            }).catch((err) => {
                console.error(err);
            });
        },


        batchManual(){
            const ids = this.multipleSelection.map(item => item.id);
            this.$confirm("确认将数据标记为手动处理吗？", "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                center: true
            }).then(() => {
                this.reset_loading = true;
                ImportQueueService.orderQueueManual(ids).then((res) => {
                    if (res.code == 0) {
                        this.$message({
                            message: "操作成功",
                            type: "success"
                        });
                        this.submitSearch();
                    }
                    this.reset_loading = false;
                }).catch((err) => {
                    console.error(err);
                    this.reset_loading = false;
                });
            }).catch((err) => {
                console.error(err);
            });
        },

        handleSizeChange(newSize) {
            // 处理每页条目数变化事件
            this.searcheModel['perPage'] = newSize;
            this.submitSearch();
        },

        handleCurrentChange(newPage) {
            // 处理当前页码变化事件
            this.searcheModel['page'] = newPage;
            this.submitSearch();
        },

        handleView(row) {
            let path = "/customers/view?id=" + row.customer_id;
            let to = this.$router.resolve({
                path: path
            });
            window.open(to.href, '_blank');
        },

        handleClick(tab, event) {
            this.submitSearch();
        },

        importSuccess(){
            this.submitSearch();
        },

        handleSelectionChange(val) {
            this.multipleSelection = val;
        }
    },
  };
  </script>



// WEBPACK FOOTER //
// src/views/customer/importOrder.vue